import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { LoginComponent } from './login/login.component';
import { ConfirmationModalComponent } from './modals/confirmation-modal/confirmation-modal.component';
import { RegisterComponent } from './register/register.component';
import { UsersComponent } from './users/users.component';


@NgModule({
  declarations: [
    ConfirmationModalComponent,
    LoginComponent,
    RegisterComponent,
    UsersComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ]
})
export class AccountModule { }
